export default "__VITE_ASSET__B6ABwism__"